import { render } from "./sectionb.vue?vue&type=template&id=e3a36698"
import script from "./sectionb.vue?vue&type=script&lang=js"
export * from "./sectionb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__